<ng-container formGroupName="individualAnalyses">
    <label class="container">
        <div>
            <div
                style="
                    display: flex;
                    align-items: center;
                    gap: 7px;
                    line-height: 24px;
                "
                [ngStyle]="{'font-size': small ? '13px' : '16px'}"
            >
                <div style="white-space: nowrap;" *ngIf="label">
                    {{ label }}
                </div>
                <div *ngIf="code">({{ code }})</div>

                <div style="color: #82c940" *ngIf="stared">★</div>
                <div style="color: #82c940" *ngIf="notEqual">≠</div>
            </div>
        </div>
        <input [formControlName]="name" type="checkbox" />
        <span class="checkmark"></span>
    </label>
    <div style="margin-left: 26px;margin-top: -5px;">
        <ng-content></ng-content>
    </div>
</ng-container>
